<template>
  <div ref="scrollZoomWrapper">
    <slot :value="value" />
    <zoom-controls
      v-if="showControls && allowZoom"
      v-bind="$props"
      :value="value"
      @input="changeZoomFactor"
    >
      <template #extra-buttons>
        <slot name="buttons" />
      </template>
    </zoom-controls>
  </div>
</template>

<script>
import ZoomControls from './ZoomControls';

const ZOOM_DIVISOR = 16;

export default {
  components: {
    'zoom-controls': ZoomControls,
  },
  props: {
    allowZoom: {
      type: Boolean,
      default: true,
    },
    showControls: {
      type: Boolean,
      default: true,
    },
    ...ZoomControls.props,
  },
  mounted() {
    if (this.allowZoom) {
      this.addScrollListener();
    }
  },
  beforeUnmount() {
    if (this.allowZoom) {
      this.removeScrollListener();
    }
  },
  methods: {
    addScrollListener() {
      setTimeout(() => {
        const { scrollZoomWrapper } = this.$refs;
        if (scrollZoomWrapper) {
          scrollZoomWrapper.addEventListener(
            'mousewheel',
            this.handleZoomScroll,
          );
          scrollZoomWrapper.addEventListener(
            'DOMMouseScroll',
            this.handleZoomScroll,
          );
        }
      }, 400);
    },
    removeScrollListener() {
      const { scrollZoomWrapper } = this.$refs;
      if (scrollZoomWrapper) {
        scrollZoomWrapper.removeEventListener(
          'mousewheel',
          this.handleZoomScroll,
        );
        scrollZoomWrapper.removeEventListener(
          'DOMMouseScroll',
          this.handleZoomScroll,
        );
      }
    },
    handleZoomScroll(event) {
      if (event.ctrlKey) {
        event.preventDefault();
        const deltaY =
          event.deltaY !== undefined ? event.deltaY : -event.wheelData;
        this.changeZoomFactor((-deltaY * this.zoomStep) / ZOOM_DIVISOR);
      }
    },
    changeZoomFactor(increment) {
      const { scrollZoomWrapper } = this.$refs;
      const scrollTopPercentage =
        scrollZoomWrapper.scrollTop / scrollZoomWrapper.scrollHeight;
      const scrollLeftPercentage =
        scrollZoomWrapper.scrollLeft / scrollZoomWrapper.scrollWidth;

      this.$emit(
        'input',
        Math.min(this.maxZoom, Math.max(this.minZoom, this.value + increment)),
      );
      setTimeout(() => {
        scrollZoomWrapper.scrollTop =
          scrollZoomWrapper.scrollHeight * scrollTopPercentage;
        scrollZoomWrapper.scrollLeft =
          scrollZoomWrapper.scrollWidth * scrollLeftPercentage;
      }, 1);
    },
  },
};
</script>
